import { useEffect } from 'react';
import { useLocation } from 'react-router';

/**
 * On every navigation: scroll to the hash target if present, otherwise scroll to top.
 * Place this hook in layout components that wrap routed pages.
 */
export function useHashScroll() {
  const { hash, pathname } = useLocation();

  useEffect(() => {
    if (hash) {
      const id = hash.replace('#', '');
      const frame = requestAnimationFrame(() => {
        const el = document.getElementById(id);
        if (el) el.scrollIntoView({ behavior: 'smooth' });
      });
      return () => {
        cancelAnimationFrame(frame);
      };
    }

    window.scrollTo(0, 0);
  }, [hash, pathname]);
}
